import type { OrganizationAncestorLinkProps } from "./organization-ancestor-link.type";

import { Link } from "react-router";

import { getOrganizationAncestor } from "@/entities/ancestor";

const OrganizationAncestorLink = ({
  ancestors,
}: OrganizationAncestorLinkProps) => {
  const organization = getOrganizationAncestor(ancestors);

  if (!organization) return null;

  return (
    <Link to={`/organizations/${organization.id}`}>{organization.name}</Link>
  );
};

export default OrganizationAncestorLink;
